<template>
  <div>
    <div class="px-6 md:px-10 lg:px-40 pt-10 pb-6 text-center">
      <h1
        class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#3DCBB1] tracking-tight"
      >
        {{ $t("course.title") }}
      </h1>
      <p class="text-gray-400 text-sm mt-2">
        {{ $t("course.subtitle") }}
      </p>
    </div>

    <section
      v-if="cards.length"
      class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-6 md:px-10 lg:px-40 pb-20"
    >
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="relative rounded-[20px] overflow-hidden group"
      >
        <NuxtLink :to="`/block/${card.block_id}`">
          <img
            :src="card.thumbnail"
            :alt="card.title"
            class="w-full h-[400px] object-cover transition duration-300 group-hover:scale-105"
          />
          <div
            class="absolute inset-0 bg-black/50 flex flex-col items-center justify-center px-6 text-center"
          >
            <h4
              class="text-white/50 text-2xl md:text-2xl lg:text-3xl font-semibold"
            >
              {{ card.title }}
            </h4>
          </div>
        </NuxtLink>
      </div>
    </section>

    <div
      v-else
      class="text-center text-gray-400 py-20 text-xl sm:text-2xl px-6 md:px-10 lg:px-40"
    >
      📦 {{ $t("course.empty_line1") }}<br />
      {{ $t("course.empty_line2") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useSupabaseClient } from "#imports";

interface Card {
  block_id: number;
  title: string;
  thumbnail: string;
}

const cards = ref<Card[]>([]);
const supabase = useSupabaseClient();

// YouTube ID ayıklayıp thumbnail üret
function getYoutubeThumbnail(youtubeLink: string): string {
  const regex =
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([^&\n?#]+)/;
  const match = youtubeLink.match(regex);
  const id = match ? match[1] : "";
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}

onMounted(async () => {
  const { data, error } = await supabase
    .from("moduls")
    .select("*")
    .eq("status", true)
    .order("id", { ascending: true });

  if (error) {
    console.error("Supabase fetch error:", error.message);
    return;
  }

  if (data) {
    // Her blok için sadece ilk video baz alınır
    const grouped = Object.values(
      data.reduce(
        (acc, lesson) => {
          if (!acc[lesson.id]) {
            acc[lesson.id] = lesson;
          }
          return acc;
        },
        {} as Record<number, any>
      )
    );

    cards.value = grouped.map((lesson: any) => ({
      block_id: lesson.id,
      title: `${lesson.name}`,
      thumbnail: getYoutubeThumbnail(lesson.youtube_link ?? null),
    }));
  }
});
</script>

<style scoped>
/* Tailwind tabanlı, ekstra stil gerekmez */
</style>
